import { defineComponent as n, computed as o } from "vue";
import { getConfig as a } from "./component-library2.js";
import u from "./component-library6.js";
import f from "./component-library5.js";
import l from "./component-library9.js";
import m from "./component-library8.js";
import c from "./component-library3.js";
import g from "./component-library33.js";
import p from "./component-library34.js";
const y = /* @__PURE__ */ n({
  __name: "card",
  props: {
    size: { default: "default" },
    interactiveBg: { type: Boolean },
    background: { default: void 0 },
    image: { default: void 0 },
    imageBackground: { default: void 0 },
    brand: { default: void 0 },
    badge: { default: void 0 },
    imagePosition: { default: "top" },
    imagePositionXs: { default: "top" },
    tag: { default: "div" },
    heading: { default: void 0 },
    label: { default: void 0 },
    subtitle: { default: void 0 },
    buttons: { default: void 0 },
    text: { default: void 0 },
    role: { default: void 0 },
    href: { default: void 0 },
    isExternal: { type: Boolean },
    isLink: { type: Boolean },
    customClass: { default: void 0 },
    customStyles: { default: void 0 },
    squareBadge: { default: void 0 },
    squareBadgeReverse: { type: Boolean }
  },
  emits: ["clicked"],
  setup(r, { emit: t }) {
    const e = r, s = o(() => {
      const i = [];
      return i.push(`card--${e.size}`), e.customClass && i.push(e.customClass), (e.href || e.isLink) && i.push("card--has-link"), (e.interactiveBg || e.href || e.isLink) && i.push("card--interactive-bg"), (e.image?.src || e.imagePosition) && i.push("card--image"), e.imagePositionXs && i.push(`card--image-xs-${e.imagePositionXs}`), e.imagePosition && i.push(`card--image-${e.imagePosition}`), i;
    }), d = o(() => e.tag === "nuxt-link" && !e.href ? "span" : e.tag === "nuxt-link" && a()?.nuxtLink ? a().nuxtLink : e.tag);
    return { __sfc: !0, props: e, cardClasses: s, componentTag: d, emit: t, onClick: (i) => {
      t("clicked", i);
    }, Heading: u, Paragraph: f, PictureElement: l, ImageElement: m, LinkButton: c, Badge: g, SquareBadge: p };
  }
});
export {
  y as default
};
